import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Table, TableBody, TableHead, TableRow, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import { HeadTableCell, RowTableCell } from '../../../common/components';
import CheckIcon from '@mui/icons-material/Check';
import { usePrintInvoice } from '../../../hooks/useInvoices';
import { formatCurrency, formatDate, formatDateTime } from '../../../utils/formatUtils';

const PaymentsDetailsDialog = ({ open, onClose, detailsData, dialogInfo }) => {
  const printInvoiceMutation = usePrintInvoice();

  const handlePrint = (invoice_uuid) => {
    printInvoiceMutation.mutate(invoice_uuid);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>
        Facturas Realizadas el {dialogInfo?.invoiceDate ? formatDateTime(dialogInfo.invoiceDate) : ''}, Entidad Rec: {dialogInfo?.collectorEntity}, Total de comprobantes: {detailsData?.length || 0}
        <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <HeadTableCell>Fecha Factura</HeadTableCell>
              <HeadTableCell>NºFactura Int.</HeadTableCell>
              <HeadTableCell>Contrato</HeadTableCell>
              <HeadTableCell>Suscriptor</HeadTableCell>
              <HeadTableCell>Entidad Rec.</HeadTableCell>
              <HeadTableCell>Total Cupon</HeadTableCell>
              <HeadTableCell>Total Factura</HeadTableCell>
              <HeadTableCell>Facturado</HeadTableCell>
              <HeadTableCell>Imprimir</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {detailsData?.map((coupon, index) => (
              <TableRow key={index}>
                <RowTableCell>
                  Pago: {dialogInfo?.paymentDate ? formatDate(dialogInfo.paymentDate) : ''}<br />
                  Fact.: {dialogInfo?.invoiceDate ? formatDate(dialogInfo.invoiceDate) : ''}
                </RowTableCell>
                <RowTableCell>{coupon.invoice_number}</RowTableCell>
                <RowTableCell>
                  Contrato n° {coupon.contract_number}<br />
                  {coupon.fee}
                </RowTableCell>
                <RowTableCell>
                  {coupon.subscribers?.split(',').map((subscriber, idx) => (
                    <span key={idx}>{subscriber}<br /></span>
                  ))}
                </RowTableCell>
                <RowTableCell>{dialogInfo?.collectorEntity}</RowTableCell>
                <RowTableCell>{formatCurrency(coupon.total_coupon)}</RowTableCell>
                <RowTableCell>{formatCurrency(coupon.total_invoiced)}</RowTableCell>
                <RowTableCell style={{ textAlign: 'center' }}>
                  <CheckIcon color="primary" />
                </RowTableCell>
                <RowTableCell style={{ textAlign: 'center' }}>
                  <IconButton size="small" color="primary" onClick={() => handlePrint(coupon.invoice_uuid)}>
                    <PrintIcon />
                  </IconButton>
                </RowTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentsDetailsDialog;
